<div class="svg-arrow-wrapper">
  <svg
      viewBox="0 0 210 297"
      [attr.height]="height">
    <g
        id="layer1">
      <path *ngIf="!color"
          d="M 119.7186,148.5 10.909528,39.685934 50.590588,3.286966e-6 199.09047,148.5 m -79.37187,0 L 10.909528,257.31406 50.590588,297 199.09047,148.5"
          style="fill:var(--theme-color);fill-opacity:1;stroke:none;stroke-width:0.1"
          id="path1576"/>
      <path *ngIf="color"
          d="M 119.7186,148.5 10.909528,39.685934 50.590588,3.286966e-6 199.09047,148.5 m -79.37187,0 L 10.909528,257.31406 50.590588,297 199.09047,148.5"
          [style]="'fill:' + color + ';fill-opacity:1;stroke:none;stroke-width:0.1'"
          id="path1576"/>
    </g>
  </svg>
</div>
